import "./jiraResults.css";

export default function JiraResults(props) {
    return (
        <>
            {props.jiras?.map((jira, index) => {
                return (
                    
                    <a href={jira.url} draggable="false" target="_blank" rel="nonreferrer" className="link-container" key={index}>
                        <div className="search-result-container" key={index}>
                            <div className="header">
                                <div>
                                    <h2>{jira.title}</h2>
                                    <p className="sub-header">Last updated {jira.lastUpdated} - {jira.url}</p>
                                </div>
                                <span className="category">{jira.category}</span>
                            </div>
                            {/* <div style={{textAlign: "left", margin: "20px 0px"}}>
                                <span className="tag">{jira.list}</span>
                            </div> */}
                        {jira.description && (
                            <div className="description">
                                <pre className="jira-description">
                                    {jira.description}
                                </pre>
                            </div>
                        )}
                        </div>
                    </a>
                    // {hoverIndex === trello.id ? <TrelloPreviewModal card={trello} /> : ""}
                )
            })}
        </>
    )
}